import React from "react";
import { useTheme } from "@mui/material";
import { RotatingLines } from "react-loader-spinner";
import { Navigate } from "react-router-dom";
import AuthService from "../core/services/auth";

function PrivateRoute({ children }) {
    const isAuthenticated = AuthService.isUserLoggedIn();
    const theme = useTheme();

    console.log("isAuthenticated:", isAuthenticated);

    if (isAuthenticated === null || isAuthenticated === undefined) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <RotatingLines height={50} width={50} strokeColor={theme.palette.primary.main} />
            </div>
        );
    }

    return isAuthenticated ? children : <Navigate to="/" />;
}

export { PrivateRoute };
